import useApi from '../hooks/api/useApi';
import useMutate from '../hooks/api/useMutate';

export function useLocationsDropdown() {
  const url = `/locations/dropdown`;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    locations: data?.data || [],
    error,
    isLoading,
    refresh
  };
}

export function useAutoCompleteAPI(search, isTyping, endpoint) {
  const trimmed = search?.trim() || '';

  const shouldSearch = trimmed.length >= 2 && isTyping;

  const url = shouldSearch ? `${endpoint}?search=${encodeURIComponent(trimmed)}` : null;

  const { data, error, isLoading } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    results: data?.data || [],
    error,
    isLoading
  };
}

//api for fetching location based on city

export function useGetRestaurantOutlets(filters) {
  const locationId = filters?.location_id;

  const url = locationId ? `/locations/restaurants?location_id=${locationId}` : null;

  const { data, error, isLoading, refresh } = useApi(url, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    outlets: data?.data?.outlets || [],
    total_outlets: data?.data?.total_outlets || 0,
    success: data?.success ?? false,
    error,
    isLoading,
    refresh
  };
}

// export function useGetRestaurantHolidays(location_id) {
//   const url = location_id ? `/restaurants/upcoming-holidays` : null;

//   const payload = location_id ? { location_id } : null;

//   const { data, error, isLoading, refresh } = useApi(url, {
//     method: 'POST',
//     body: payload,
//     revalidateOnFocus: false,
//     revalidateOnReconnect: false,
//     revalidateIfStale: false
//   });

//   const holidays = data?.data?.holidays || [];

//   return {
//     holidays,
//     location: data?.data?.location || null,
//     success: data?.success ?? false,
//     error,
//     isLoading,
//     refresh
//   };
// }

export function useGetRestaurantHolidays() {
  const { post, isMutating } = useMutate('/restaurants/upcoming-holidays');

  const getRestaurantHolidays = async (locationId) => {
    if (!locationId) {
      return {
        holidays: [],
        location: null,
        success: false,
        nonWorkingDays: []
      };
    }

    try {
      const res = await post({ location_id: locationId });

      return {
        holidays: res?.data?.holidays || [],
        location: res?.data?.location || null,
        success: res?.success ?? false,
        nonWorkingDays: res?.data?.non_working_days || []
      };
    } catch (error) {
      console.error('Holiday fetch error:', error);
      return {
        holidays: [],
        location: null,
        success: false,
        nonWorkingDays: []
      };
    }
  };

  return {
    getRestaurantHolidays,
    isMutating
  };
}
